export default __webpack_public_path__ + "media/pro/browser-23611a0a.svg";